@if (!isMobile) {
    <h2 mat-dialog-title>
        Filtrer
        <mat-icon class="closeDialogBtn" color="primary" mat-dialog-close>clear</mat-icon>
    </h2>

    <div mat-dialog-content>
        @if (isTagsLoaded) {
            <div class="mainContainer">
                @for (cat of categoriesAndTag; track $index) {
                    <div class="filterContainer">
                        <p class="categoryTitle">Par {{ cat.n }}</p>
                        <mat-form-field class="selectCat" appearance="outline">
                            <mat-select [value]="allModels[$index]" multiple placeholder="Filtrer par {{ cat.n }}">
                                @for (tag of cat.t; track $index) {
                                    <mat-option [value]="tag.n" (click)="selectSubMenu(tag, cat)">
                                        {{ tag.n }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                }
            </div>
        } @else {
            <mat-spinner></mat-spinner>
        }
    </div>

    <div mat-dialog-actions style="justify-content: center">
        <button (click)="validFilter()" class="validBtn" mat-fab extended color="primary">Valider</button>
    </div>
} @else {
    <div #focusDiv [@openClose]="displayMobileFilterPanel ? 'open' : 'close'" class="mobileContainer">
        @if (mobileSelectedCat != null) {
            <h2>Filtrer {{ mobileSelectedCat.n != null ? 'par ' + mobileSelectedCat?.n : '& Grouper' }}</h2>
        } @else {
            <h2>Filtrer & Trier</h2>
        }

        <mat-icon class="closeDialogBtn" color="primary" (click)="goBack()">clear</mat-icon>

        @if (isTagsLoaded) {
            <div class="filterContainer">
                @if (mobileSelectedCat == null) {
                    <!-- MARK: Vue de base (Grouper Par + Categories) -->

                    <!-- Grouper Par -->
                    @if (hasGroupByOptions()) {
                        <article class="mobileCatBtn" matRipple (click)="selectCategoryMobile(categoriesAndTag)">
                            <p class="categoryTitle">Grouper Par</p>

                            <div class="groupedTitle">
                                <p class="categoryTitle">{{ groupByName }}</p>
                                <mat-icon>arrow_forward_ios</mat-icon>
                            </div>
                        </article>
                    }

                    @for (cat of categoriesAndTag; track $index) {
                        <article class="mobileCatBtn" matRipple (click)="selectCategoryMobile(cat)">
                            <p class="categoryTitle">Par {{ cat.n }}</p>

                            <mat-icon>arrow_forward_ios</mat-icon>
                        </article>
                    }
                } @else {
                    @if (mobileSelectedCat?.t != null) {
                        <!-- MARK: Liste des tags dans la catégorier sélectionnée -->
                        @for (tag of mobileSelectedCat.t; track $index) {
                            <div
                                [ngClass]="{ selected: isTagSelected(tag, mobileSelectedCat) }"
                                class="mobileCatBtn"
                                matRipple
                                (click)="selectSubMenu(tag, mobileSelectedCat)"
                            >
                                <p class="categoryTitle">
                                    @if (isTagSelected(tag, mobileSelectedCat)) {
                                        <mat-icon>check</mat-icon>
                                    }
                                    {{ tag.n }}
                                </p>
                            </div>
                        }
                    } @else {
                        <article class="mobileCatBtn" matRipple (click)="groupBy(null)">
                            <p class="categoryTitle">--</p>
                        </article>
                        @for (cat of categoriesAndTag; track $index) {
                            @if (cat.i) {
                                <article class="mobileCatBtn" matRipple (click)="groupBy(cat.i)">
                                    <p class="categoryTitle">Par {{ cat.n }}</p>
                                </article>
                            }
                        }
                    }
                }
            </div>

            <div class="validBtnContainer">
                <button mat-flat-button color="primary" (click)="validFilter()" class="validBtn">Valider</button>
            </div>
        } @else {
            <mat-spinner></mat-spinner>
        }
    </div>
}
